<template lang="html">
  <section :id="id" class="toggle-button">
    <div :dir="rightToLeftDir">
      <div class="slds-form-element">
        <label class="slds-checkbox_toggle slds-grid">
          <span
            v-if="label"
            class="slds-form-element__label slds-m-bottom_none label"
          >
            {{ label }}
          </span>
          <input
            type="checkbox"
            v-model="model"
            @change.stop="onCheckboxChange"
          />
          <span class="slds-checkbox_faux_container">
            <span class="slds-checkbox_faux"></span>
            <span v-if="enabledText" class="slds-checkbox_on">
              {{ enabledText }}
            </span>
            <span v-if="disabledText" class="slds-checkbox_off">
              {{ disabledText }}
            </span>
          </span>
        </label>
      </div>
    </div>
  </section>
</template>

<script lang="js">

  export default {
    name: "toggle-button",
    props: {
      id: String,
      label: String,
      enabledText: String,
      disabledText: String,
      on: Boolean,
      rightToLeft: Boolean
    },
    data() {
      return {
        model: ""
      }
    },
    watch: {
      on: function() {
        this.updateModel();
      }
    },
    computed: {
      rightToLeftDir() {
        return this.rightToLeft? "rtl" : "";
      }
    },
    mounted() {
      this.updateModel();
    },
    methods: {
      updateModel() {
        this.model = this.on;
      },
      onCheckboxChange() {
        this.$emit("on-toggle-button-change", this.model, this.id);
      }
    }
  };
</script>

<style scoped lang="scss">
  .toggle-button {
    display: flex;
    align-items: center;
    .label {
      font-size: 0.8125rem;
      white-space: nowrap;
    }
    .slds-grid {
      align-items: center;
      margin-bottom: 0;
    }
    .slds-checkbox_faux_container {
      margin-right: 0.5rem;
    }
  }
</style>
